import React from 'react';
import { FaCheck } from 'react-icons/fa';

const CheckIcon = ({ className = "check", style = {} }) => (
  <FaCheck 
    className={className}
    style={{
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '1',
      flexShrink: 0,
      width: '16px',
      height: '16px',
      display: 'inline-block',
      verticalAlign: 'middle',
      ...style
    }} 
  />
);

export default CheckIcon; 